<template>
  <button v-if="!editing" @click.stop="editValue" :class="{blueish}">
    <span>
      <slot></slot>
    </span>

    <svg v-if="!removeIcon" xmlns="http://www.w3.org/2000/svg" class="mb-1" width="13" height="13" viewBox="0 0 20 20" fill="currentColor">
      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
    </svg>
  </button>
  <div v-else class="new-value">
    <slot name='input'>
      <input ref="input"
        v-model="newValue"

        @keydown="saveNewValue"
        @blur="blur"
      />
    </slot>
  </div>
</template>

<script>

import fixDecimalCommaNotation from "../../mixins/fixDecimalCommaNotation"

export default {
  mixins: [fixDecimalCommaNotation()],
  props: {
    blueish: Boolean,
    removeIcon: Boolean,
    alwaysOpen: Boolean,
    
    value: {
        type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      newValue: this.value,
      editing: this.alwaysOpen || false,
    }
  },
  methods: {
    editValue() {
      this.editing = true
      this.newValue = this.value

      this.$emit('opened-field')
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus())
    },
    blur() {
      if (this.alwaysOpen && this.newValue !== this.value) {
        this.$emit("save", this.fixComma(this.newValue))
      }
    },
    saveNewValue({key}) {
      if (key !== "Enter") return;

      this.$emit("save", this.fixComma(this.newValue))
      if (!this.alwaysOpen)this.editing = false
    },
    checkPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      if (!found && !this.alwaysOpen) this.editing = false
    },
  },
  watch: {
    editing(val) {
      if (val && this.newValue === "---") {
        this.newValue = ""
      }
      
      this.$emit("editing", val)
      if (val) {
        window.addEventListener("click", this.checkPath)
      } else {
        window.removeEventListener("click", this.checkPath)
      }
    },
  },
}

</script>

<style scoped>

input {
  border: 1px solid #E3E3E3;
  padding: 4px;
  border-radius: 1px;
  width: 150px;
  position: relative;
}

.blueish {
  color: #0081C9;
}

</style>
